import api from "../services/api";

export const downloadSampleCsvUrl = (phone_id) =>
  `${api.defaults.baseURL}/api/contact-imports/sample-csv?phone_id=${encodeURIComponent(phone_id)}`;

export const downloadSampleCsv = () =>
  api.get("/api/contact-imports/sample-csv", { responseType: "blob" });

export const previewImport = (file, phone_id) => {
  const fd = new FormData();
  fd.append("csvFile", file);
  fd.append("phone_id", phone_id);
  return api.post("/api/contact-imports/preview", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const startImport = ({ file, phone_id, list_id, mapping, source = "csv" }) => {
  const fd = new FormData();
  fd.append("csvFile", file);
  fd.append("phone_id", phone_id);
  if (list_id) fd.append("list_id", list_id);
  fd.append("mapping", JSON.stringify(mapping));
  fd.append("source", source);
  return api.post("/api/contact-imports", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getImportJob = (id) => api.get(`/api/contact-imports/${id}`);
export const listImportJobs = (params) => api.get(`/api/contact-imports`, { params });
export const errorsCsvUrl = (id) =>
  `${api.defaults.baseURL}/api/contact-imports/${id}/errors.csv`;
